export default __webpack_public_path__ + "static/media/word.548c6b2d.svg";